import * as cx from 'classnames';
import * as React from 'react';
import styles from './PostMenuTrigger.mscss';

interface OwnProps {
    onClick: React.MouseEventHandler<HTMLElement>;
}

type Props = OwnProps;

class PostMenuTrigger extends React.Component<Props> {

    public render() {
        const { onClick } = this.props;

        return (
            <i
                className={cx('fa fa-chevron-down', styles.PostMenuTrigger)}
                onClick={onClick}
                role="button"
                tabIndex={0}
            />
        );
    }

}

export default PostMenuTrigger;
